<div *ngIf="reportType == 'unpaidOutstandingVbriefly'">
  <div class="container" id="print-section">
    <table class="report-table">
      <thead>
        <tr>
          <th colspan="2" class="br-bottom br-right br-top" style="font-size: medium;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
          </th>
          <th colspan="2" class="br-bottom br-right br-top small-text">
            Advt. Outstanding Report
          </th>
          <th colspan="2" class="br-bottom br-right br-top small-text">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th colspan="3" class="br-bottom br-right small-text">Very Briefly</th>
          <th colspan="3" class="br-bottom small-text">
            Date: From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th class="br-bottom br-right small-text" style="text-align: center;">Representative</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Advt Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">GST Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Net Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Rcv Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let data of onlyOutstandingVB">
          <!-- Office Representative -->
          <tr>
            <td colspan="6" class="br-bottom br-top bold-text off_rep_name">
              Office Representative Name :
              <span style="font-weight: bold; font-size: 17px;">
                {{ data.off_rep_name }} / {{ data.office_rep_mob }}
              </span>
            </td>
          </tr>

          <!-- Representative + Totals only -->
          <ng-container *ngFor="let data1 of data.rep_data">
            <tr>
              <td class="br-bottom br-top br-right bold-text">
                {{ data1.rep_name }} / {{ data1.rep_mob }}
              </td>
              <td class="br-bottom br-top br-right bold-text" style="text-align: right;">
                {{ (data1.adv_total * 1).toFixed(2) }}
              </td>
              <td class="br-bottom br-top br-right bold-text" style="text-align: right;">
                {{ (data1.gst_total * 1).toFixed(2) }}
              </td>
              <td class="br-bottom br-top br-right bold-text" style="text-align: right;">
                {{ (data1.net_total * 1).toFixed(2) }}
              </td>
              <td class="br-bottom br-top br-right bold-text" style="text-align: right;">
                {{ (data1.rcv_total * 1).toFixed(2) }}
              </td>
              <td class="br-bottom br-top br-right bold-text" style="text-align: right;">
                {{ (data1.bal_total * 1).toFixed(2) }}
              </td>
            </tr>
          </ng-container>

          <!-- Totals per Office Rep -->
          <tr style="background-color: #eaeaea;">
            <td class="br-bottom br-top br-right bold-text">
              Total: {{ data.off_rep_name }}
            </td>
            <td class="br-bottom br-top br-right" style="text-align: right; font-size: 16px; font-weight: bold;">
              {{ (data.adv_total * 1).toFixed(2) }}
            </td>
            <td class="br-bottom br-top br-right" style="text-align: right; font-size: 16px; font-weight: bold;">
              {{ (data.gst_total * 1).toFixed(2) }}
            </td>
            <td class="br-bottom br-top br-right" style="text-align: right; font-size: 16px; font-weight: bold;">
              {{ (data.net_total * 1).toFixed(2) }}
            </td>
            <td class="br-bottom br-top br-right" style="text-align: right; font-size: 16px; font-weight: bold;">
              {{ (data.rcv_total * 1).toFixed(2) }}
            </td>
            <td class="br-bottom br-top br-right" style="text-align: right; font-size: 16px; font-weight: bold;">
              {{ (data.bal_total * 1).toFixed(2) }}
            </td>
          </tr>
        </ng-container>

        <!-- Grand Total -->
        <tr style="background-color: lightgray;">
          <td class="br-bottom br-top br-right bold-text">Grand Total (All Reps)</td>
          <td class="br-bottom br-top br-right bold-text" style="text-align: right; font-size: 18px;">
            {{ (onlytotalAdvtAmount * 1).toFixed(2) }}
          </td>
          <td class="br-bottom br-top br-right bold-text" style="text-align: right; font-size: 18px;">
            {{ (onlytotalGstUnpaidAmount * 1).toFixed(2) }}
          </td>
          <td class="br-bottom br-top br-right bold-text" style="text-align: right; font-size: 18px;">
            {{ (onlytotalNetAmount * 1).toFixed(2) }}
          </td>
          <td class="br-bottom br-top br-right bold-text" style="text-align: right; font-size: 18px;">
            {{ (onlytotalRcvUnpaidAmount * 1).toFixed(2) }}
          </td>
          <td class="br-bottom br-top bold-text" style="text-align: right; font-size: 18px;">
            {{ (onlytotalUnpaidAmount * 1).toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="footer-line"></div>
  </div>

  <!-- Action Buttons -->
  <div class="actions noPrint">
    <button mat-raised-button color="primary" (click)="exportExcel('Contract_InDetails_Report')">Export</button>
    <button mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
